import * as Sentry from "@sentry/vue";

let hasReplayInit = false;

async function lazyLoadSentryIntegrations() {
    // don't load on server
    if (!process.client) return;

    // only load once
    if (hasReplayInit) return;

    const client = Sentry.getCurrentHub().getClient();
    if (!client || !client.addIntegration) {
        console.error('Could not add replay integration');
    }

    try {
        const replay = new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
        });

        console.log('Adding replay integration');
        client.addIntegration(replay)
        hasReplayInit = true;
    } catch (error) {
        console.error('Could not add replay integration', error);            
    }

}

function getSentryIntegrations() {
    // don't load on server
    if (!process.client) return [];

    const router = useRouter();
    const browserTracing = Sentry.browserTracingIntegration({ router });

    return [browserTracing, Sentry.replayIntegration()];
}

export default defineNuxtPlugin(async ({ vueApp }) => {
    
    const config = useRuntimeConfig();
    
    if (!config.public.ENABLE_SENTRY) return;
    if (!config.public.SENTRY_DSN_PUBLIC) return;

    Sentry.init({
        app: vueApp,
        dsn: config.public.SENTRY_DSN_PUBLIC,
        integrations: getSentryIntegrations(),

        // Establecer tracesSampleRate en 1.0 para capturar el 100%
        // de transacciones para monitoreo de rendimiento.
        // Recomendamos ajustar este valor en producción
        tracesSampleRate: config.public.SENTRY_TRACES_SAMPLE_RATE as number,

        // Establecer `tracePropagationTargets` para controlar en qué URLs se debe habilitar el seguimiento distribuido
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

        // Esto establece la tasa de muestra. Puedes querer que sea del 100% mientras
        // en desarrollo y muestrear a una tasa más baja en producción
        replaysSessionSampleRate: config.public.SENTRY_REPLAY_SAMPLE_RATE as number,

        // Si no se muestrea toda la sesión, utiliza la tasa de muestra a continuación para muestrear
        // sesiones cuando ocurra un error.
        replaysOnErrorSampleRate: config.public.SENTRY_ERROR_REPLAY_SAMPLE_RATE as number,
    });

    // Carga perezosamente la integración de replay para reducir el tamaño del paquete
    lazyLoadSentryIntegrations();
});
